import {svgIconWrapper} from '../svg-icon-wrapper';

import GlobeRegular from './globe-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <GlobeRegular {...validProps} />;
}

SvgComponent.iconName = 'globeRegular';

export const GlobeRegularIcon = svgIconWrapper(SvgComponent);
